export enum SkipAction {
  Skip,
  UnSkip,
}
